import React from 'react';
import { useDefaultDashboardRedirect } from './root';

export default function Home() {
    useDefaultDashboardRedirect();

    return <div data-testid="route-home"></div>;
}
